/*
 * Categories drawer: opens the /pages/categories menu as a slide-up sheet.
 * - The menu HTML is the page's own section, fetched with the Section Rendering API
 *   (section id is learned from the first full-page fetch, then reused).
 * - Prefetched when the browser is idle, cached in sessionStorage.
 * - Back button / Escape / close button close it; the trigger stays a real link.
 */
(function () {
  var drawer = document.getElementById("CategoriesDrawer");
  if (!drawer) return;

  var CACHE_TTL = 30 * 60 * 1000;
  var url = drawer.getAttribute("data-url");
  var content = drawer.querySelector("[data-cn-drawer-content]");
  var cacheKey = "cn-drawer:" + url;
  var idKey = "cn-drawer-section:" + url;

  var loadPromise = null;
  var assetsPromise = null;
  var isOpen = false;
  var lastTrigger = null;
  var closeTimer = 0;

  function storage(type) {
    try {
      var s = window[type];
      var k = "__cn";
      s.setItem(k, k);
      s.removeItem(k);
      return s;
    } catch (e) {
      return null;
    }
  }
  var session = storage("sessionStorage");
  var local = storage("localStorage");

  function readCache() {
    if (!session) return null;
    try {
      var c = JSON.parse(session.getItem(cacheKey) || "null");
      if (c && Date.now() - c.t < CACHE_TTL) return c.html;
    } catch (e) {}
    return null;
  }
  function writeCache(html) {
    if (!session) return;
    try {
      session.setItem(cacheKey, JSON.stringify({ t: Date.now(), html: html }));
    } catch (e) {}
  }

  function extract(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var menu = doc.querySelector(".category-navigation-page");
    if (!menu) return null;
    var wrapper = menu.closest(".shopify-section");
    if (wrapper && wrapper.id && local) {
      try {
        local.setItem(idKey, wrapper.id.replace(/^shopify-section-/, ""));
      } catch (e) {}
    }
    // Scripts/styles are loaded by this file; the host page already has its own <h1>
    menu.querySelectorAll("script, link[rel='stylesheet'], h1").forEach(function (el) {
      el.remove();
    });
    return menu.outerHTML;
  }

  function fetchText(u) {
    return fetch(u, { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
  }

  function fetchMenu() {
    var sectionId = local && local.getItem(idKey);
    var full = function () {
      return fetchText(url).then(extract);
    };
    if (!sectionId) return full();
    var sep = url.indexOf("?") > -1 ? "&" : "?";
    return fetchText(url + sep + "section_id=" + encodeURIComponent(sectionId))
      .then(extract)
      .then(function (html) {
        return html || full();
      })
      .catch(full);
  }

  function loadAssets() {
    if (assetsPromise) return assetsPromise;
    var css = new Promise(function (resolve) {
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = drawer.getAttribute("data-css");
      link.onload = link.onerror = resolve;
      document.head.appendChild(link);
    });
    var js = window.LolaCategoriesNav
      ? Promise.resolve()
      : new Promise(function (resolve, reject) {
          var s = document.createElement("script");
          s.src = drawer.getAttribute("data-js");
          s.onload = resolve;
          s.onerror = reject;
          document.head.appendChild(s);
        });
    assetsPromise = Promise.all([css, js]);
    return assetsPromise;
  }

  function load() {
    if (loadPromise) return loadPromise;
    var cached = readCache();
    var html = cached ? Promise.resolve(cached) : fetchMenu();
    loadPromise = Promise.all([html, loadAssets()])
      .then(function (res) {
        if (!res[0]) throw new Error("menu not found");
        if (!cached) writeCache(res[0]);
        content.innerHTML = res[0];
        var root = content.querySelector(".category-navigation-page");
        if (window.LolaCategoriesNav) window.LolaCategoriesNav.init(root);
        drawer.classList.add("is-ready");
      })
      .catch(function (err) {
        loadPromise = null;
        throw err;
      });
    return loadPromise;
  }

  function setInert(on) {
    document
      .querySelectorAll("#MainContent, .shopify-section-group-header-group, .shopify-section-group-footer-group")
      .forEach(function (el) {
        if (on) el.setAttribute("inert", "");
        else el.removeAttribute("inert");
      });
  }

  function setTriggerState(on) {
    document.querySelectorAll("[data-cn-drawer-trigger]").forEach(function (a) {
      a.classList.toggle("active", on);
      a.setAttribute("aria-expanded", on ? "true" : "false");
    });
  }

  function open(trigger) {
    if (isOpen) return;
    isOpen = true;
    lastTrigger = trigger || null;
    clearTimeout(closeTimer);
    drawer.hidden = false;
    // Force layout so the slide-in transition runs
    void drawer.offsetHeight;
    drawer.classList.add("is-open");
    document.documentElement.classList.add("cn-drawer-open");
    setInert(true);
    setTriggerState(true);
    history.pushState({ cnDrawer: true }, "");

    load()
      .then(function () {
        if (!isOpen) return;
        var first = drawer.querySelector(".cn-tab.is-active") || drawer.querySelector("button, a");
        if (first) first.focus({ preventScroll: true });
      })
      .catch(function () {
        // Fall back to the real page
        window.location.href = url;
      });
  }

  function close(fromHistory) {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("cn-drawer-open");
    setInert(false);
    setTriggerState(false);
    closeTimer = setTimeout(function () {
      if (!isOpen) drawer.hidden = true;
    }, 350);
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
    if (!fromHistory && history.state && history.state.cnDrawer) history.back();
  }

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-cn-drawer-trigger]");
    if (trigger) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (isOpen) close();
      else open(trigger);
      return;
    }
    if (isOpen && e.target.closest("#CategoriesDrawer [data-cn-close]")) {
      e.preventDefault();
      close();
      return;
    }
    // Another bottom-bar item (home, cart, wishlist) was tapped: get out of the way
    if (isOpen && e.target.closest(".mobile-navigation-bar a")) close(true);
  });

  window.addEventListener("popstate", function () {
    if (isOpen) close(true);
  });
  document.addEventListener("keydown", function (e) {
    if (isOpen && e.key === "Escape") close();
  });
  // Leaving the page from inside the drawer: reset state for bfcache restores
  window.addEventListener("pageshow", function (e) {
    if (e.persisted && isOpen) close(true);
  });
  // Resized so the bottom bar disappeared: close rather than leave a sheet with no Menu button
  window.addEventListener("resize", function () {
    if (isOpen && !triggerVisible()) close();
  }, { passive: true });

  // Warm up on first touch of the trigger only. The menu is fetched when someone reaches
  // for it, not in the background on every mobile page (most visits never open it).
  document.addEventListener(
    "pointerdown",
    function (e) {
      if (e.target.closest("[data-cn-drawer-trigger]")) load().catch(function () {});
    },
    { passive: true }
  );
  // Only when a Menu button is actually on screen (the bottom bar is hidden on wider screens)
  function triggerVisible() {
    var t = document.querySelector("[data-cn-drawer-trigger]");
    return !!(t && t.getClientRects().length);
  }
})();
